import React from 'react';
import Slider from 'rc-slider';
import PropTypes from 'prop-types';

class AlphaSliderComponent extends React.PureComponent {
  static propTypes = {
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired
  }

  get percentFloat () {
    return (1 - this.props.value) * 100;
  }

  get percentString () {
    return this.percentFloat.toFixed(2);
  }

  render () {
    return (
      <div className="mb-15" data-testid="confidenceInterval-slider">
        <p className="font-14 opacity-50 mb-10 flex space-between">
          <span>
            {this.percentString}
            % Confidence Interval
          </span>

          <span>
            &#945; =
            {' '}
            {this.props.value.toFixed(2)}
          </span>
        </p>

        <Slider min={0.01} max={0.99} step={0.01} className="main-slider" {...this.props} />
      </div>
    );
  }
}

export default AlphaSliderComponent;
